import { useState } from "react";
import { Check, Send } from "lucide-react";
import { CampoSelect } from "../components/campos.jsx";
import { TOOLS } from "../data/tools.js";

const FORMSPREE = import.meta.env.VITE_FORMSPREE_ID || "xaqkjjnn";

const TIPOS = [
  { valor: "new_tool", etiqueta: "Nueva herramienta" },
  { valor: "improvement", etiqueta: "Mejora de una herramienta" },
  { valor: "bug", etiqueta: "Reportar un error" },
  { valor: "general", etiqueta: "Comentario general" },
];

export default function Sugerir() {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [tipo, setTipo] = useState("new_tool");
  const [herramienta, setHerramienta] = useState("General");
  const [mensaje, setMensaje] = useState("");
  const [estado, setEstado] = useState("edicion");

  async function enviar(e) {
    e.preventDefault();
    if (!nombre.trim() || !mensaje.trim()) return;
    setEstado("enviando");

    const carga = {
      name: nombre,
      email: email || "No proporcionado",
      _replyto: email || undefined,
      type: TIPOS.find((t) => t.valor === tipo)?.etiqueta ?? tipo,
      tool: tipo === "improvement" || tipo === "bug" ? herramienta : "N/A",
      message: mensaje,
      timestamp: new Date().toLocaleString("es-MX"),
      source: "tu-kit.com",
    };

    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(carga),
      });
      // El formulario anterior mostraba "enviado" pasara lo que pasara,
      // incluso cuando Formspree rechazaba la petición.
      setEstado(res.ok ? "enviado" : "error");
    } catch {
      setEstado("error");
    }
  }

  if (estado === "enviado") {
    return (
      <div className="space-y-4 py-10 text-center">
        <span className="inline-block rounded-full bg-[color:var(--positivo-bg)] p-3 text-[color:var(--positivo)]">
          <Check className="h-6 w-6" aria-hidden="true" />
        </span>
        <h3 className="text-lg font-bold text-[color:var(--texto)]">¡Gracias! Recibimos tu propuesta</h3>
        <p className="mx-auto max-w-md text-sm texto-2">
          Leemos todo lo que llega por aquí. Si dejaste tu correo, te avisamos cuando la herramienta
          esté lista.
        </p>
        <button
          onClick={() => {
            setEstado("edicion");
            setMensaje("");
          }}
          className="acento text-sm font-semibold underline-offset-4 hover:underline"
        >
          Enviar otra propuesta
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={enviar} className="mx-auto max-w-2xl space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="sug-nombre" className="etiqueta">Tu nombre *</label>
          <input id="sug-nombre" required className="campo" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </div>
        <div>
          <label htmlFor="sug-email" className="etiqueta">Correo (opcional)</label>
          <input
            id="sug-email"
            type="email"
            className="campo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Para avisarte cuando esté lista"
          />
        </div>
      </div>

      <CampoSelect label="Tipo de propuesta" valor={tipo} onChange={setTipo} opciones={TIPOS} />

      {(tipo === "improvement" || tipo === "bug") && (
        <CampoSelect
          label="¿Sobre qué herramienta?"
          valor={herramienta}
          onChange={setHerramienta}
          opciones={[
            { valor: "General", etiqueta: "General / todo el sitio" },
            ...TOOLS.filter((t) => t.id !== "tool_sugerir").map((t) => ({ valor: t.name, etiqueta: t.name })),
          ]}
        />
      )}

      <div>
        <label htmlFor="sug-mensaje" className="etiqueta">Cuéntanos *</label>
        <textarea
          id="sug-mensaje"
          required
          rows={5}
          className="campo resize-y"
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          placeholder="¿Qué necesitas calcular? Entre más concreto, mejor."
        />
      </div>

      {estado === "error" && (
        <p className="rounded-xl border border-[color:var(--alerta-borde)] bg-[color:var(--alerta-bg)] p-3 text-2xs text-[color:var(--alerta)]">
          No pudimos enviar tu mensaje. Revisa tu conexión e inténtalo de nuevo, o escríbenos
          directamente desde la página de contacto.
        </p>
      )}

      <button
        type="submit"
        disabled={estado === "enviando"}
        className="inline-flex items-center gap-2 rounded-lg bg-[color:var(--acento)] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[color:var(--acento)] disabled:opacity-60"
      >
        <Send className="h-4 w-4" aria-hidden="true" />
        {estado === "enviando" ? "Enviando…" : "Enviar propuesta"}
      </button>
    </form>
  );
}
